import { useState } from 'react';
import { FaBell, FaCog, FaSearch, FaBars } from 'react-icons/fa';
import Greeting from 'utils/Greeting';
import { IoIosArrowDown } from "react-icons/io";
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import useAppContext from 'context/AppContext';

interface HeaderProps {
    toggleSidebar?: () => void;
    isSidebarOpen?: boolean;
}

const Header = ({ toggleSidebar }: HeaderProps) => {
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const { userDetail } = useAppContext();

    const greeting = Greeting();

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleLogout = () => {
        navigate('/logout');
    };

    const handleFunctionButton = () => {
        message.info("coming soon!");
    }

    return (
        <div className="header flex justify-between items-center px-3 md:px-6 bg-teal-50">
            {/* Greeting Section */}
            <div className="flex items-center space-x-2 md:space-x-4 p-2 md:p-4">
                {toggleSidebar && (
                    <button
                        type="button"
                        onClick={toggleSidebar}
                        className="p-2 rounded-lg bg-white border border-teal-100 shadow-xs text-green-900 hover:bg-green-50 active:scale-95 transition-all md:hidden"
                        title="Buka Menu Navigasi"
                    >
                        <FaBars size={18} />
                    </button>
                )}
                <div>
                    <h1 className="text-xs text-gray-500">{greeting},</h1>
                    <p className="text-sm md:text-lg font-semibold leading-tight">{userDetail?.name} 👋</p>
                </div>
            </div>

            {/* Right Section with Icons and Profile */}
            <div className="flex items-center space-x-1.5 md:space-x-4">
                {/* Search Icon */}
                <div className="p-2 bg-white rounded-full shadow-sm flex items-center justify-center cursor-pointer hover:bg-gray-50"
                    onClick={handleFunctionButton}>
                    <FaSearch className="text-gray-600" size={16} />
                </div>

                {/* Notification Icon */}
                <div className="p-2 bg-white rounded-full shadow-sm flex items-center justify-center cursor-pointer hover:bg-gray-50"
                    onClick={handleFunctionButton}>
                    <FaBell className="text-gray-600" size={16} />
                </div>

                {/* Settings Icon */}
                <div className="p-2 bg-white rounded-full shadow-sm flex items-center justify-center cursor-pointer hover:bg-gray-50"
                    onClick={() => navigate(`/settings`)}>
                    <FaCog className="text-gray-600" size={16} />
                </div>

                {/* User Profile */}
                <div className="flex items-center space-x-1.5 py-1.5 px-3 md:py-2 md:px-4 bg-white rounded-full shadow-sm cursor-pointer hover:bg-gray-50"
                    onClick={toggleDropdown}>
                    <span className="text-xs md:text-sm text-gray-800 font-medium truncate max-w-[80px] md:max-w-none">{userDetail?.name}</span>
                    <IoIosArrowDown className="text-xs" />
                </div>

                {isDropdownOpen && (
                    <div className="absolute right-3 md:right-5 top-14 w-44 bg-white rounded-lg shadow-lg z-50 border border-gray-100">
                        <button
                            className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-50 rounded-lg"
                            onClick={handleLogout}
                        >
                            Logout
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Header;
